export default {
  state: {
    teacherInfo: {
      isLogin: false,
      ttoken: "",
      timestamp: "",
    }
  },
  mutations: {
    login(state, data) {
      state.teacherInfo = {
        isLogin: true,
        ttoken: data.ttoken,
        deadLine: Date.parse(new Date()) + 7 * 24 * 60 * 60 * 1000
      }

      window.localStorage.setItem('loginInfo', JSON.stringify(state.teacherInfo));
    }
  },

  getters: {
    ttoken(state) {
      let lsLoginInfo = JSON.parse(window.localStorage.getItem('loginInfo'));
      if (lsLoginInfo && Date.parse(new Date()) < lsLoginInfo.deadLine) {
        return lsLoginInfo.ttoken;
      } else {
        return state.teacherInfo.ttoken;
      }
    }
  },

  actions: {
    teacher_login({ commit }, data) {
      commit("login", data);
    },
  }
}
